import {
  FranchisePubInfoWrapper,
  FranchisePubInfoRow,
  FranchisePubLikeWrapper,
  PremiumStoreInfoWrapper,
} from "./styles";
import { SkeletonContainer, SkeletonText } from "./styles/skeleton";

const FranchiseItemSkeleton = () => {
  return (
    <PremiumStoreInfoWrapper>
      <SkeletonContainer>
        <FranchisePubInfoWrapper>
          <FranchisePubInfoRow>
            <SkeletonText width="100%" height="auto" ratio="1/1" />
          </FranchisePubInfoRow>
        </FranchisePubInfoWrapper>
        <FranchisePubInfoWrapper style={{ marginTop: "8px" }}>
          <FranchisePubInfoRow>
            <SkeletonText width="90%" height="14px" />
            <SkeletonText width="80%" height="26px" />
          </FranchisePubInfoRow>
          <FranchisePubLikeWrapper>
            <SkeletonText width="100%" height="12px" />
            <SkeletonText width="100%" height="100%" />
          </FranchisePubLikeWrapper>
        </FranchisePubInfoWrapper>
      </SkeletonContainer>
    </PremiumStoreInfoWrapper>
  );
};

export default FranchiseItemSkeleton;
